import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import CreateForm from "./steps/CreateForm";
import StepTwo from "./steps/Two";
import DownloadApp from "./steps/DownloadApp";
import Verification from "./steps/Verification";

export default class MultiStep extends Component {
  renderSteps = () => {
    const steps = [
      { step: "one" },
      { step: "two", path: "create/:appId" },
      { step: "three", path: "verification/:appId" },
      { step: "four", path: "download/:appId" }
    ];
    let currentStep = 0;
    if (this.props.location.pathname.match("create")) currentStep = 1;
    else if (this.props.location.pathname.match("verification")) currentStep = 2;
    else if (this.props.location.pathname.match("download")) currentStep = 3;
    const totalSteps = steps.length - 1;
    const stepValue = (currentStep / totalSteps) * 100;
    return (
      <div className="container justify-content-md-center">
        <div className="form-progress">
          <progress
            className="form-progress-bar"
            min="0"
            max="100"
            value={stepValue}
            step={currentStep + 1}
            aria-labelledby="form-progress-completion"
          />

          {steps.map((item, key) => (
            <div
              className={`form-progress-indicator ${item.step} active`}
              key={`item-${key}`}
            />
          ))}
          <p
            id="form-progress-completion"
            className="js-form-progress-completion sr-only"
            aria-live="polite"
          />
        </div>
      </div>
    );
  };
  render() {
    const rootPath = "/pwa-to-apk";
    return (
      <section className="generator-step-1 container">
        <div className="row padding m-auto">
          <div className="col-lg-5 d-none d-lg-block d-sm-none m-auto">
            <img
              src="https://storage.googleapis.com/appilder_cdn/wordpress-theme/pwa-apk/images/appmaker-pwa.png"
              alt=""
              className="spotlight-image-green"
            />
          </div>

          <div className="step-1 col-lg-7 col-sm-12 m-auto active">
            {this.renderSteps()}
            <Router>
              <div className="row padding m-auto">
                <Route
                  exact
                  path={`${rootPath}/`}
                  component={CreateForm}
                />
                <Route
                  exact
                  path={`/`}
                  component={CreateForm}
                />
                <Route
                  path={`${rootPath}/create/:appId`}
                  component={StepTwo}
                />
                <Route
                  path={`${rootPath}/verification/:appId`}
                  component={Verification}
                />
                <Route
                  path={`${rootPath}/download/:appId`}
                  component={DownloadApp}
                />
              </div>
            </Router>
          </div>
        </div>
      </section>
    );
  }
}
